<!-- Table with parts views  -->
<app-paginator
  [length]="app.partsTable.size"
  [index]="app.paginator.focus"
  (focus)="app.paginator.focus = $event"
  [type]="'partsTable'"
></app-paginator>
<app-modal
  #deletePartModal
  [modalMessage]="app.text.part.deletePart"
  [modalTitle]="app.text.part.deleteModal"
  (ok)="app.detailTable.deleteBOMItem('part')"
></app-modal>

<div>
  @if (app.table.selected.size > 0) {
    <button
      class="btn btn-sm btn-default-orange pull-right my-2"
      (click)="deletePartModal.open()"
      >
      <i class="fas fa-trash"></i> &nbsp;
      {{ app.text.app.delete }}
    </button>
  }
</div>
<div
  class="tableFixHead clear"
  [ngClass]="{ tableHeight: app.filterTable.isDropdownOpen }"
  >
  <table class="table table-striped spacing-table">
    <thead>
      <tr>
        @for (column of app.partsTable.partsTableColumns; track column) {
          <th
            class="p-1"
            [title]="app.table.setHeaderTooltip('part.' + column)"
            >
            <div class="d-inline-flex">
              <div
              [ngClass]="{
                'resize-table': app.table.canColumnBeResized(column)
              }"
                >
                <div
                  class="pointer"
                  (click)="sortColumn(column)"
                  [innerHtml]="app.partsTable.getPartsHeaderLabels(column)"
                  [ngClass]="app.table.getSizeOfColumn(column)"
                ></div>
              </div>
            </div>
            &nbsp;
            @if ('part.' + column === app.table.sortField) {
              <span>
                @if (app.table.sortDirection === 1) {
                  <i
                    class="fa fa-chevron-up"
                  ></i>
                }
                @if (app.table.sortDirection === -1) {
                  <i
                    class="fa fa-chevron-down"
                  ></i>
                }
              </span>
            }
            @if (app.filterTable.getFilterTableColumns(column)) {
              <div>
                <app-filter-header-table [column]="column" [docType]="'part'">
                </app-filter-header-table>
              </div>
            }
            <!-- <div *ngIf="app.filterTable.getFilterTableColumns(column)">
            <app-filter-table
              [column]="column"
              [columns]="app.partsTable.getPartsTableColumns()"
              [docType]="'part'"
              [cleanDocs]="app.partsTable.cleanParts"
              [selectedFilters]="selectedFilters"
              [resetComponent]="resetFilterInputsObservable"
              (resultedDocs)="app.filterTable.getFilterResults($event, 'part')"
              >
            </app-filter-table>
          </div> -->
        </th>
      }
      @if (
        app.RM.mode === 'parts-to-be-deleted' ||
        app.RM.mode === 'not-used-assemblies'
        ) {
        <th
          class="p-1"
          >
          {{ app.text.app.delete }}
          <div>
            @if (app.table.selected.size === 0) {
              <i
                class="far fa-square"
                (click)="app.table.selectAll(app.partsTable.parts)"
              ></i>
            }
            @if (app.table.selected.size > 0) {
              <i
                class="far fa-check-square"
                (click)="app.table.clearSelection()"
              ></i>
            }
          </div>
        </th>
      }
    </tr>
  </thead>
  <tbody>
    @for (id of app.partsTable.parts; track id) {
      <tr>
        @for (column of app.partsTable.partsTableColumns; track column) {
          <td class="p-1">
            <div>
              @switch (app.table.getColumnTypeDisplay(column)) {
                @case ('normal') {
                  <span>
                    @if (column !== 'stockRange') {
                      <span
                        [ngbTooltip]="getPartCellTooltip(column, id[column])"
                        >
                        {{ id[column] }}
                      </span>
                    }
                    @if (column === 'stockRange' && id[column] > -1) {
                      <span>
                        {{ id[column] }}
                      </span>
                    }
                  </span>
                }
                @case ('textCenter') {
                  <div class="text-center">
                    {{ id[column] }}
                  </div>
                }
                @case ('navigateAction') {
                  <div>
                    @if (column === 'partNumber') {
                      <a
                        class="partNumber parts-table-cpn-link"
                        (click)="app.part.navigateToPartDetails(id[column])"
                        >
                        @if (id.parts && (id.parts | keyvalue).length > 0) {
                          <i
                            class="fas fa-cube parts-table-cpn-icon parts-table-cpn-icon-assembly"
                            aria-hidden="true"
                          ></i>
                        }
                        @if (!id.parts || (id.parts | keyvalue).length === 0) {
                          <i
                            class="fas fa-cog parts-table-cpn-icon parts-table-cpn-icon-part"
                            aria-hidden="true"
                          ></i>
                        }
                        <span class="parts-table-cpn-copy">
                          <span class="parts-table-cpn-value">{{ id[column] }}</span>
                        </span>
                      </a>
                    } @else {
                      <a
                        class="partNumber"
                        (click)="app.part.navigateToPartDetails(id[column])"
                        >
                        {{ id[column] }}
                      </a>
                    }
                  </div>
                }
                @case ('badge') {
                  <div>
                    @if (id[column] !== 'withoutData') {
                      <span
                        class="badge text-center compact-parts-table-badge"
                [ngClass]="{
                  'status-column-badge':
                    column === 'obsolescenceStatus' ||
                    column === 'obsolescenceStatus2years' ||
                    column === 'obsolescenceStatus4years' ||
                    column === 'obsolescenceStatus6years' ||
                    column === 'obsolescenceStatus8years',
                  'non-status-column-badge':
                    column !== 'obsolescenceStatus' &&
                    column !== 'obsolescenceStatus2years' &&
                    column !== 'obsolescenceStatus4years' &&
                    column !== 'obsolescenceStatus6years' &&
                    column !== 'obsolescenceStatus8years'
                }"
                        [ngStyle]="app.field.getColor('part.' + column, id[column])"
                        >
                        {{ app.field.getOptionText("part." + column, id[column]) }}
                      </span>
                    }
                  </div>
                }
                @case ('radio') {
                  <div>
                    @if (app.field.isTrue(id[column])) {
                      <i class="far fa-dot-circle"></i>
                    }
                    @if (app.field.isFalse(id[column])) {
                      <i class="fal fa-circle"></i>
                    }
                  </div>
                }
                @case ('partsToVehicles') {
                  <div
                    >
                    <i
                      class="fas fa-sitemap fa-rotate-270 pointer icon-blue p-1"
                (click)="
                  selectedWhereUsedPartNumber = id['partNumber'];
                  seeWhereUsedTreeModal.open();
                  $event.stopPropagation()
                "
                      [title]="app.text.part.whereUsed"
                    ></i>
                  </div>
                }
                @case ('actions') {
                  <div>
                    @if (column == 'threadCase') {
                      <span>
                        @if (hasOpenCases(id)) {
                          <i
                            class="fas fa-folder-open icon-blue pointer p-1"
                  (click)="
                    seeOpenedCasesModal.open();
                    app.treeCell.currentRow = id;
                    getThreadsByPartNumber(id._id)
                  "
                          ></i>
                        }
                      </span>
                    }
                  </div>
                }
                @case ('limit') {
                  <div class="fixedWidth">
                    <span (click)="$event.stopPropagation()">
                      <app-limit [textInput]="id[column]" limit="20"> </app-limit>
                    </span>
                  </div>
                }
                @case ('decimalNumber') {
                  <div>
                    @if (id[column] > -1) {
                      <span>
                        {{ app.field.formatNumberWithDecimals(id[column], 2) }}
                      </span>
                    }
                  </div>
                }
              }
            </div>
          </td>
        }
        @if (
          app.RM.mode === 'parts-to-be-deleted' ||
          app.RM.mode === 'not-used-assemblies'
          ) {
          <td
            class="p-1"
            >
            <button
              class="btn btn-hidden pt-0 ps-0"
              (click)="app.table.toggleSelect(id); $event.stopPropagation()"
              >
              @if (app.table.selected.has(id)) {
                <i
                  class="far fa-check-square"
                ></i>
              }
              @if (!app.table.selected.has(id)) {
                <i class="far fa-square"></i>
              }
            </button>
          </td>
        }
      </tr>
    }
    <tr>
      @if (loading) {
        <td colspan="99" class="text-center">
          {{ this.app.text.core.loading }}
        </td>
      }
      @if (!loading && app.partsTable.parts.length === 0) {
        <td
          colspan="99"
          class="text-center"
          >
          {{ this.app.text.core.noResults }}
        </td>
      }
    </tr>
  </tbody>
</table>
</div>
<app-paginator
  [length]="app.partsTable.size"
  [index]="app.paginator.focus"
  (focus)="app.paginator.focus = $event"
  [type]="'partsTable'"
></app-paginator>

<app-modal
  #seeWhereUsedTreeModal
  [modalTitle]="app.text.part.whereUsed"
  [showButtons]="false"
  [modalType]="'showWhereUsedTree'"
  [whereUsedCustomer]="app.customers.expectCurrent"
  [whereUsedPartNumber]="selectedWhereUsedPartNumber"
  >
</app-modal>
<app-modal
  #seeOpenedCasesModal
  [modalTitle]="app.text.thread.threads"
  [modalType]="'showListOfCases'"
  [showButtons]="false"
  >
</app-modal>
